<div class="eg-page">

  <div class="eg-head">
    <h2>Employees</h2>
    <span class="eg-sub">Global search across all sites &amp; companies (super-admin)</span>
  </div>

  <div class="eg-loading" *ngIf="loading">
    <mat-spinner diameter="28"></mat-spinner> Loading employees…
  </div>

  <div class="eg-body" *ngIf="!loading">

    <!-- LEFT: search + results -->
    <div class="eg-left">
      <mat-form-field appearance="outline" class="eg-search">
        <mat-icon matPrefix>search</mat-icon>
        <mat-label>Search name or email</mat-label>
        <input matInput [(ngModel)]="search" (ngModelChange)="applyFilter()">
      </mat-form-field>
      <div class="eg-count">{{ employees.length | number }} employees · showing {{ filtered.length }}</div>

      <div class="eg-list">
        <button class="eg-item" *ngFor="let e of filtered" [class.on]="selected?.id === e.id" (click)="select(e)">
          <span class="eg-item-name">{{ e.name || '(no name)' }}</span>
          <span class="eg-item-email">{{ e.email }}</span>
          <span class="eg-item-badge" [class.multi]="e.membershipCount > 1">{{ e.membershipCount }} site{{ e.membershipCount === 1 ? '' : 's' }}</span>
        </button>
        <div class="eg-empty" *ngIf="filtered.length === 0">No employees match.</div>
        <div class="eg-more" *ngIf="!search && employees.length > filtered.length">
          Type to search the remaining {{ employees.length - filtered.length | number }}…
        </div>
      </div>
    </div>

    <!-- RIGHT: selected employee detail -->
    <div class="eg-right">
      <div class="eg-placeholder" *ngIf="!selected">Select an employee to see their memberships across all sites.</div>

      <div *ngIf="selected">
        <div class="eg-detail-head">
          <div>
            <div class="eg-detail-name">{{ selected.name || '(no name)' }}</div>
            <div class="eg-detail-email">{{ selected.email }}</div>
          </div>
          <div class="eg-detail-meta">
            <span class="eg-chip" [class.ok]="selected.gdprAccepted">GDPR {{ selected.gdprAccepted ? 'accepted' : 'no' }}</span>
            <span class="eg-chip">{{ selectedMemberships.length }} membership{{ selectedMemberships.length === 1 ? '' : 's' }}</span>
            <button mat-stroked-button matTooltip="Set a new password for this employee" (click)="resetPassword()">
              <mat-icon>lock_reset</mat-icon> Reset password
            </button>
            <button mat-stroked-button matTooltip="Email the employee a link to set their own password" (click)="sendResetEmail()">
              <mat-icon>mail</mat-icon> Send reset email
            </button>
          </div>
        </div>

        <table class="eg-table">
          <thead>
            <tr><th>Company</th><th>Site</th><th>Group</th><th>Credit</th><th>Status</th><th></th></tr>
          </thead>
          <tbody>
            <tr *ngFor="let m of selectedMemberships">
              <td>{{ m.companyLabel }}</td>
              <td>{{ m.siteLabel }}</td>
              <td>{{ m.groupLabel }}</td>
              <td>{{ m.credit }}</td>
              <td>
                <span class="eg-status" [class.on]="m.status">{{ m.status ? 'Active' : 'Inactive' }}</span>
              </td>
              <td class="eg-actions">
                <button mat-icon-button matTooltip="View ledger" (click)="openLedger(m)"><mat-icon>receipt_long</mat-icon></button>
                <button mat-icon-button matTooltip="Edit" (click)="editMembership(m)"><mat-icon>edit</mat-icon></button>
                <button mat-icon-button matTooltip="Remove from this site" (click)="deleteMembership(m)"><mat-icon>delete</mat-icon></button>
              </td>
            </tr>
            <tr *ngIf="selectedMemberships.length === 0">
              <td colspan="6" class="eg-empty">This employee has no active memberships.</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

  </div>
</div>
